import React from "react";
import styled from '@emotion/styled'
import "./style.css";

const LinearGauge = (props) => {

  const { linearGaugeValues, deviceValue, displayName } = props;
  // EXAMPLE DATA: 
  // linearGaugeValues = ({
  // hwId: DIGI_SCU
  // valueName: SampleFlow
  // lowWarning: 0.7
  // highWarning: 1.3
  // lowAlarm: 0.5
  // highAlarm: 1.5
  // optimal: null
  //   });

  //Create object with empty values to be populated, we need the null values which are not coming from backend
  let objectWithAllValues = {
    "lowWarning": null,
    "lowAlarm": null,
    "optimal": 0,
    "highWarning": null,
    "highAlarm": null
  }

  //populate the object with data if there is any
  if (linearGaugeValues.lowWarning) {
    objectWithAllValues.lowWarning = linearGaugeValues.lowWarning
  }
  if (linearGaugeValues.lowAlarm) {
    objectWithAllValues.lowAlarm = linearGaugeValues.lowAlarm
  }
  if (linearGaugeValues.highWarning) {
    objectWithAllValues.highWarning = linearGaugeValues.highWarning
  }
  if (linearGaugeValues.highAlarm) {
    objectWithAllValues.highAlarm = linearGaugeValues.highAlarm
  }
  //optimal needs to be calculated (doesn't come from backend)
  if (linearGaugeValues.optimal) {
    objectWithAllValues.optimal = linearGaugeValues.optimal
  } else if ((linearGaugeValues.highWarning) && (linearGaugeValues.lowWarning)) {
    objectWithAllValues.optimal = linearGaugeValues.lowWarning + ((linearGaugeValues.highWarning - linearGaugeValues.lowWarning) / 2)
  } else if ((linearGaugeValues.lowAlarm) && (linearGaugeValues.highAlarm)) {
    objectWithAllValues.optimal = linearGaugeValues.lowAlarm + ((linearGaugeValues.highAlarm - linearGaugeValues.lowAlarm) / 2)
  } else if ((linearGaugeValues.lowAlarm) && (linearGaugeValues.lowWarning)) {
    objectWithAllValues.optimal = (linearGaugeValues.lowAlarm + linearGaugeValues.lowWarning) * 2
  }

  const translateDeviceValue = () => {
    let _deviveValue = deviceValue;
    _deviveValue = Number(_deviveValue)

    // if deviceValue is "free volume", the deviceValue needs to be converted into fill value for linear gauge display purposes
    // matters only if linear gauge type is "fill"
    if (displayName === "Free Volume") {
      _deviveValue = linearGaugeMax - deviceValue
    }
    return (_deviveValue);
  }

  const calculateLinearGaugeMin = () => {
    let lgMinValue = 0;
    if (!objectWithAllValues.lowAlarm) {
      let range = Math.abs(objectWithAllValues.highAlarm) - Math.abs(objectWithAllValues.optimal);
      lgMinValue = objectWithAllValues.optimal - Math.abs(range)
      return (lgMinValue)
    }
    if (objectWithAllValues.lowAlarm > 0) {
      lgMinValue = objectWithAllValues.lowAlarm * 0.9;
    } else if (objectWithAllValues.lowAlarm < 0) {
      lgMinValue = objectWithAllValues.lowAlarm * 1.1;
    }
    lgMinValue = lgMinValue.toFixed(2)
    return (lgMinValue)
  }

  const calculateLinearGaugeMax = () => {
    let lgMaxValue = 0;
    if (!objectWithAllValues.highAlarm) {
      lgMaxValue = objectWithAllValues.optimal - objectWithAllValues.lowAlarm;
      return (lgMaxValue)
    }
    if (objectWithAllValues.highAlarm > 0) {
      lgMaxValue = objectWithAllValues.highAlarm * 1.1;
    } else if (objectWithAllValues.highAlarm < 0) {
      lgMaxValue = objectWithAllValues.highAlarm * 0.9;
    }
    lgMaxValue = lgMaxValue.toFixed(2)
    return (lgMaxValue)
  }

  // If there are only low values OR only high values, use linearGaugeType = "fill". Otherwise use "normal"
  const determineLinearGaugeType = (objectWithAllValues) => {
    let linearGaugeType = "";

    if (!objectWithAllValues.lowWarning && !objectWithAllValues.lowAlarm && (objectWithAllValues.optimal === 0)) {
      linearGaugeType = "fill";
    } else if (objectWithAllValues.lowWarning && objectWithAllValues.lowAlarm &&
      (objectWithAllValues.optimal > objectWithAllValues.lowWarning) &&
      (!objectWithAllValues.highWarning) && (!objectWithAllValues.highAlarm)) {
      linearGaugeType = "fill";
    } else {
      linearGaugeType = "normal";
    }
    return (linearGaugeType)
  }

  const linearGaugeMin = calculateLinearGaugeMin(); // <input type='range' min=linearGaugeMin >
  const linearGaugeMax = calculateLinearGaugeMax(); // <input type='range' max=linearGaugeMax >
  const linearGaugeType = determineLinearGaugeType(objectWithAllValues); //normal or fill type
  const _deviveValue = translateDeviceValue(); // if linear gauge value is e.g. "free volume", it need to be translated to fillvalue

  //function for determining linearGauge styling. Styles: normal - warning - alarm 
  const calculateLinearGaugeStyle = (_deviveValue, linearGaugeValues) => {
    let linearGaugeStyle = "";

    if ((_deviveValue > linearGaugeValues.highAlarm) || (_deviveValue < linearGaugeValues.lowAlarm)) {
      linearGaugeStyle = "linear-gauge-alarm";
    } else if (
      ((linearGaugeValues.highWarning) && (linearGaugeValues.lowWarning)) &&
      ((_deviveValue > linearGaugeValues.highWarning) && (_deviveValue < linearGaugeValues.highAlarm)) ||
      ((linearGaugeValues.highWarning) && (linearGaugeValues.lowWarning)) &&
      ((_deviveValue < linearGaugeValues.lowWarning) && (_deviveValue > linearGaugeValues.lowAlarm))
    ) {
      linearGaugeStyle = "linear-gauge-warning";
    } else {
      linearGaugeStyle = "linear-gauge";
    }
    return (linearGaugeStyle)
  }

  //function for determining linearGauge-fill (alternate version of linearGauge) styling. Styles: normal - warning - alarm 
  const calculateLinearGaugeFillStyle = (_deviveValue, linearGaugeFillValues) => {
    let linearGaugeStyle = "";

    // if linearGaugeFillValues contains only highWarning and highAlarm values
    if (linearGaugeFillValues.highAlarm) {
      if (_deviveValue > linearGaugeFillValues.highAlarm) {
        linearGaugeStyle = "linear-gauge-fill-alarm";
      } else if ((_deviveValue > linearGaugeFillValues.highWarning) && (_deviveValue < linearGaugeFillValues.highAlarm)) {
        linearGaugeStyle = "linear-gauge-fill-warning";
      } else {
        linearGaugeStyle = "linear-gauge-fill";
      }
    }
    // if linearGaugeFillValues contains only lowWarning and lowAlarm values
    if (linearGaugeFillValues.lowAlarm) {
      if (_deviveValue < linearGaugeFillValues.lowAlarm) {
        linearGaugeStyle = "linear-gauge-fill-alarm";
      } else if ((_deviveValue < linearGaugeFillValues.lowWarning) && (_deviveValue > linearGaugeFillValues.lowAlarm)) {
        linearGaugeStyle = "linear-gauge-fill-warning";
      } else {
        linearGaugeStyle = "linear-gauge-fill";
      }
    }
    return (linearGaugeStyle)
  }


  //COMPONENT for drawing the linear gauge tick marks
  const LinearGaugeTicks = (props) => {

    const { objectWithAllValues, _deviveValue } = props;

    //get linear gauges range (e.g. +30 to -30 = 60). Needed for tick position calculations.
    const linearGaugeRange = (parseFloat(linearGaugeMax) - parseFloat(linearGaugeMin));

    //This function calculates tick mark's position in linear gauge
    const translatePosition = (thresholdValue) => {
      //      +100 +200    example of threshold values (lowAlarm AlarmHigh)
      //      +90 +220     +10% to each side is linearGauges min/max. RANGE(distance between) = 130
      //      0 130        subtract linearGaugeMin from --min and --max
      //    
      //      200-90 = 110 relativeMaxThresholdValue, from subtracting linearGaugeMin from original high thresholdValue
      //      110/130*100 = 84,6 (positon in %)

      let relativeThresholdValue = thresholdValue - linearGaugeMin; // needed so that threshold value cannot ever be higher than range
      let translatedPosition = Math.abs(parseFloat(relativeThresholdValue)) / Math.abs(parseFloat(linearGaugeRange)) * 100;
      translatedPosition = translatedPosition.toFixed(1);
      translatedPosition = translatedPosition.toString() + "%";
      return (translatedPosition);
    }

    const lowAlarmTickPosition = translatePosition(objectWithAllValues.lowAlarm)
    const lowWarningTickPosition = translatePosition(objectWithAllValues.lowWarning)
    const optimalTickPosition = translatePosition(objectWithAllValues.optimal)
    const highWarningTickPosition = translatePosition(objectWithAllValues.highWarning)
    const highAlarmTickPosition = translatePosition(objectWithAllValues.highAlarm)

    const Tick = styled.span(
      {
        content: "''",
        position: "absolute",
      },
      props => ({ left: props.tickPosition })
    );

    return (
      <>
        {objectWithAllValues.lowAlarm !== null ?
          (_deviveValue < objectWithAllValues.lowAlarm) ?
            <Tick className="tick-alarm-value-active" tickPosition={lowAlarmTickPosition} />
            : <Tick className="tick-alarm-value" tickPosition={lowAlarmTickPosition} />
          : null}
        {objectWithAllValues.lowWarning !== null ?
          (_deviveValue < objectWithAllValues.lowWarning) ?
            <Tick className="tick-warning-value-active" tickPosition={lowWarningTickPosition}></Tick>
            : <Tick className="tick-warning-value" tickPosition={lowWarningTickPosition} />
          : null}
        {objectWithAllValues.optimal !== null ?
          <Tick className="tick-optimal-value" tickPosition={optimalTickPosition}></Tick>
          : null}
        {objectWithAllValues.highWarning !== null ?
          (_deviveValue > objectWithAllValues.highWarning) ?
            <Tick className="tick-warning-value-active" tickPosition={highWarningTickPosition} />
            : <Tick className="tick-warning-value" tickPosition={highWarningTickPosition} />
          : null}
        {objectWithAllValues.highAlarm !== null ?
          (_deviveValue > objectWithAllValues.highAlarm) ?
            <Tick className="tick-alarm-value-active" tickPosition={highAlarmTickPosition} />
            : <Tick className="tick-alarm-value" tickPosition={highAlarmTickPosition} />
          : null}
      </>
    )
  }

  //LinearGauge.jsx return
  switch (linearGaugeType) {
    case "normal":
      return (
        <div className="linear-gauge-container">
          <input
            className={calculateLinearGaugeStyle(_deviveValue, objectWithAllValues)}
            readOnly type="range" step="0.1"
            min={linearGaugeMin} max={linearGaugeMax} value={_deviveValue}
          />
          <LinearGaugeTicks objectWithAllValues={objectWithAllValues} _deviveValue={_deviveValue} />
        </div>
      )
    case "fill":
      return (
        <div className="linear-gauge-container">
          <input
            className={calculateLinearGaugeFillStyle(_deviveValue, objectWithAllValues, displayName)}
            readOnly type="range" step="0.1"
            min={0} max={linearGaugeMax * 1.2} value={_deviveValue}
          />
        </div>
      )
    default:
      return null;
  }
}

export default LinearGauge;